import { TResponse } from "@/module/common"
import { TTakeListType } from "@/module/public"
import { addLearnTake, getLearnTakeList } from "@/api/public"

// 添加学习记录
export async function GetaddLearnTake(body: any) {
    await addLearnTake({
        RecordSectionId: body.RecordSectionId,
        RecordType: body.RecordType,
        RecordChapterId: body.RecordChapterId,
        RecordNum: body.RecordNum,
        Progress: body.Progress,
        ProgressTime: body.ProgressTime,
        ProgressTimes: body.ProgressTimes
    })
}

// 学习记录列表
export async function GetLearnTakeList(data: any, type:number) {
    let res: TResponse<TTakeListType> = await getLearnTakeList({
        RecordType: type,
        PageIndex: data.PageIndex,
        PageSize: data.PageSize
     })
    let { Code, Data } = res
    if (Code === 200) {
        data.list = Data.Data
        data.total = Data.Total
    }
}